import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      // odśwież komponenty, gdy z bazy dojdą nadpisane teksty
      // (addResourceBundle emituje 'added' na store -> bindI18nStore)
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added',
    },
    resources: {
      en: {
        translation: {
          nav: {
            home: 'Home',
            ourDogs: 'Our Dogs',
            litters: 'Litters',
            shows: 'Shows',
            aboutBreed: 'About the breed',
            gallery: 'Gallery',
            contact: 'Contact',
          },
          theme: {
            classic: 'Classic',
            imperial: 'Imperial',
            switch_label: 'Site design',
          },
          home: {
            hero: {
              kicker: 'Japanese Chin Kennel · FCI',
              tagline: 'Elegance, devotion and an aristocratic soul.',
              cta: 'Meet our dogs',
              scroll: 'Scroll',
            },
            about: {
              title: 'Welcome to Etsuko',
              p1: 'The Etsuko kennel was born out of a great love and fascination for the Japanese Chin breed. We are not a large, commercial kennel - we are a home where dogs are full members of the family. Our priority is the health, happiness, and excellent character of our dogs.',
              p2: 'Each pairing is carefully planned by us, and the puppies are surrounded by tender care, socialized, and prepared for life in their new homes from the very first days of their lives. We make sure that they go to responsible and loving owners.',
              p3: 'We invite you to get to know us and our dogs better.',
              imageAlt: 'Photo of the breeder with a Japanese Chin dog',
            },
            welcome: 'Welcome to Etsuko',
          },
          ourDogs: {
            title: 'Our Dogs',
            subtitle: 'The heart and pride of our kennel.',
            females_section_title: 'Our Females',
            males_section_title: 'Our Males',
            youth_section_title: 'Forever in our hearts',
            profile: {
              no_images: 'Photos will be here soon.',
              gallery_title: 'Gallery',
              pedigree_title: 'Pedigree',
            },
            placeholders: {
              female_name_1: 'Female\'s Name',
              female_title_1: 'Polish Champion',
              female_name_2: 'Another Female',
              female_title_2: 'Junior Champion',
              female_name_3: 'Third Lady',
              female_title_3: 'Our Hope',
              male_name_1: 'Male\'s Name',
              male_title_1: 'Interchampion',
              youth_name_1: 'Youngster',
              youth_title_1: 'Youth Class',
            },
            jump_to_dog_placeholder: 'Select a dog from the list...'
          },
          litters: {
            title: 'Litters',
            subtitle: 'Our little treasures, raised with love.',
            current_litters_title: 'Current Litters',
            archive_litters_title: 'Litter Archive',
            parents_label: 'Parents:',
            born_date_prefix: 'Born',
            placeholders: {
              litter_A_name: 'Litter "A"',
              litter_A_date: '01.01.2025',
              litter_A_parents: 'CH. PL. Father & CH. PL. Mother',
              litter_Z_name: 'Litter "Z"',
              litter_Z_date: '01.08.2024',
              litter_Z_parents: 'CH. PL. Another Father & CH. PL. Another Mother',
              litter_Y_name: 'Litter "Y"',
              litter_Y_date: '01.02.2024',
              litter_Y_parents: 'CH. PL. Yet Another Father & CH. PL. Yet Another Mother',
            }
          },
          shows: {
            title: 'Show Successes',
            subtitle: 'Our moments of pride in rings in Poland and Europe.',
            judge_label: 'Judge',
            placeholders: {
              show1_name: 'International Dog Show in Warsaw',
              show1_result: 'Best of Breed, CWC, CACIB',
              show2_name: 'National Dog Show in Sopot',
              show2_result: 'Best Female, CWC',
              show3_name: 'Club Show for Companion Dogs',
              show3_result: 'Excellent, 1st place',
              show4_name: 'International Dog Show in Częstochowa',
              show4_result: 'CWC, res.CACIB',
              show5_name: 'National Dog Show in Grudziądz',
              show5_result: 'Junior Winner',
            }
          },
          aboutBreed: {
            title: 'About the Breed: Japanese Chin',
            subtitle: 'An aristocrat in the dog world, with a heart full of devotion.',
            history: {
              title: 'Breed History',
              p1: 'The origin of the Japanese Chin is shrouded in mystery, but it is believed that its roots go back over a thousand years to the court of the Chinese emperor. They came to Japan as a precious gift, and there, in isolation, the breed was perfected over centuries. They were exclusively dogs of the aristocracy, and court ladies carried them in the wide sleeves of their kimonos. The first Chins arrived in Europe in the mid-19th century, presented to Queen Victoria by Commodore Perry, which began their popularity in royal courts.'
            },
            character: {
              title: 'Character and Temperament',
              p1: 'The Japanese Chin is a dog with a unique, almost cat-like character. It is intelligent, sensitive, very clean, and extremely attached to its owner. It is not noisy but can signal the arrival of guests. Chins are cheerful, love to play, but do not require intense physical effort, which makes them excellent companion dogs, ideally adapting to apartment life.',
              p2: 'These are extremely sensitive dogs that require a gentle but consistent approach. They feel best in the center of attention, showered with love and affection. In return, they offer boundless devotion and become true members of the family.'
            }
          },
          gallery: {
            title: 'Gallery',
            subtitle: "Moments from our kennel's life captured in the frame.",
            photos_count: 'photos'
          },
          contact: {
            title: 'Contact',
            subtitle: 'Have questions? Feel free to talk.',
            details: {
              title: 'Contact Details',
              name: 'Agata Columbano',
              location: 'Gdańsk, Poland'
            },
            form: {
              title: 'Write to us',
              name_label: 'Full Name',
              email_label: 'Email Address',
              message_label: 'Message',
              submit_button: 'Send Message',
              sending: 'Sending...',
              success: 'Message sent successfully! We will respond as soon as possible.',
              error: 'An error occurred while sending the message. Please try again.',
              validation: {
                name_required: 'Full name is required',
                email_required: 'Email address is required',
                email_invalid: 'Please enter a valid email address',
                message_required: 'Message is required'
              }
            },
            footer: {
              copyright: 'All rights reserved',
              createdBy: 'Created by:',
            }
          }
        }
      },
      pl: {
        translation: {
          nav: {
            home: 'Strona Główna',
            ourDogs: 'Nasze Psy',
            litters: 'Mioty',
            shows: 'Wystawy',
            aboutBreed: 'O rasie',
            gallery: 'Galeria',
            contact: 'Kontakt',
          },
          theme: {
            classic: 'Klasyczny',
            imperial: 'Imperial',
            switch_label: 'Design strony',
          },
          home: {
            hero: {
              kicker: 'Hodowla chinów japońskich · FCI',
              tagline: 'Elegancja, oddanie i arystokratyczna dusza.',
              cta: 'Poznaj nasze psy',
              scroll: 'Przewiń',
            },
            about: {
              title: 'Witaj w Etsuko',
              p1: 'Hodowla Etsuko powstała z głębokiej pasji i miłości do rasy chin japoński. Nie jesteśmy dużą, komercyjną hodowlą – nasze psy żyją z nami i są pełnoprawnymi członkami rodziny.',
              p2: 'Naszym celem jest wychowywanie zdrowych, szczęśliwych i zrównoważonych szczeniąt o doskonałym charakterze. Każde skojarzenie planujemy z najwyższą starannością, a maluchy od pierwszych dni otaczamy troskliwą opieką. Dbamy o ich socjalizację i przygotowanie do życia w nowych domach.',
              p3: 'Bardzo ważne jest dla nas, że z każdą rodziną utrzymujemy stały kontakt – chcemy wspierać naszych podopiecznych i ich opiekunów na każdym etapie życia.Zależy nam, by nasze psy trafiały do odpowiedzialnych i kochających właścicieli, którzy podzielają naszą miłość do tej wyjątkowej rasy.  Zapraszamy do bliższego poznania nas i naszych psów.',
              imageAlt: 'Zdjęcie hodowcy z psem rasy chin japoński',
            },
            welcome: 'Witaj w Etsuko',
          },
          ourDogs: {
            title: 'Nasze Psy',
            subtitle: 'Poznaj członków naszej psiej rodziny, którzy są sercem i duszą naszej hodowli.',
            females_section_title: 'Nasze Suki',
            males_section_title: 'Nasi Samce',
            youth_section_title: 'Na zawsze z nami',
            profile: {
              no_images: 'Wkrótce pojawią się tu zdjęcia.',
              gallery_title: 'Galeria',
              pedigree_title: 'Rodowód',
            },
            placeholders: {
              female_name_1: 'Imię suczki',
              female_title_1: 'Champion Polski',
              female_name_2: 'Inna suczka',
              female_title_2: 'Młodzieżowy Champion',
              female_name_3: 'Trzecia dama',
              female_title_3: 'Nasza nadzieja',
              male_name_1: 'Imię psa',
              male_title_1: 'Interchampion',
              youth_name_1: 'Młody piesek',
              youth_title_1: 'Klasa młodzieży',
            },
            jump_to_dog_placeholder: 'Wybierz psa z listy...'
          },
          litters: {
            title: 'Mioty',
            subtitle: 'Nasze małe skarby, wychowane z miłością.',
            current_litters_title: 'Aktualne Mioty',
            archive_litters_title: 'Archiwum Miotów',
            parents_label: 'Rodzice:',
            born_date_prefix: 'Urodzony',
            placeholders: {
              litter_A_name: 'Miot "A"',
              litter_A_date: '01.01.2025',
              litter_A_parents: 'CH. PL. Ojciec & CH. PL. Matka',
              litter_Z_name: 'Miot "Z"',
              litter_Z_date: '01.08.2024',
              litter_Z_parents: 'CH. PL. Inny Ojciec & CH. PL. Inna Matka',
              litter_Y_name: 'Miot "Y"',
              litter_Y_date: '01.02.2024',
              litter_Y_parents: 'CH. PL. Jeszcze Inny Ojciec & CH. PL. Jeszcze Inna Matka',
            }
          },
          shows: {
            title: 'Sukcesy Wystawowe',
            subtitle: 'Nasze chwile dumy na ringach w Polsce i Europie.',
            judge_label: 'Sędzia',
            placeholders: {
              show1_name: 'Międzynarodowa Wystawa Psów Rasowych w Warszawie',
              show1_result: 'Zwycięzca Rasy, CWC, CACIB',
              show2_name: 'Krajowa Wystawa Psów Rasowych w Sopocie',
              show2_result: 'Najlepsza Suka w Rasie, CWC',
              show3_name: 'Klubowa Wystawa Psów do Towarzystwa',
              show3_result: 'Ocena doskonała, lokata 1',
              show4_name: 'Międzynarodowa Wystawa Psów Rasowych w Częstochowie',
              show4_result: 'CWC, res.CACIB',
              show5_name: 'Krajowa Wystawa Psów Rasowych w Grudziądzu',
              show5_result: 'Zwycięzca Młodzieży',
            }
          },
          aboutBreed: {
            title: 'O Rasie: Chin Japoński',
            subtitle: 'Arystokrata w świecie psów, o sercu pełnym oddania.',
            history: {
              title: 'Historia Rasy',
              p1: 'Pochodzenie china japońskiego jest owiane tajemnicą, ale uważa się, że jego korzenie sięgają ponad tysiąc lat wstecz, na dwór chińskiego cesarza. Do Japonii trafiły jako cenny dar i tam, w izolacji, rasa była doskonalona przez wieki. Były to psy wyłącznie arystokracji, a damy dworu nosiły je w szerokich rękawach kimon. Do Europy pierwsze chiny trafiły w połowie XIX wieku, wręczone królowej Wiktorii przez komandora Perry\'ego, co zapoczątkowało ich popularność na dworach królewskich.'
            },
            character: {
              title: 'Charakter i Usposobienie',
              p1: 'Chin japoński to pies o wyjątkowym, niemal kocim charakterze. Jest inteligentny, wrażliwy, bardzo czysty i niezwykle przywiązany do swojego właściciela. Nie jest hałaśliwy, ale potrafi zasygnalizować przybycie gości. Chiny są wesołe, uwielbiają zabawy, ale nie wymagają intensywnego wysiłku fizycznego, co czyni je doskonałymi psami do towarzystwa, idealnie adaptującymi się do życia w mieszkaniu.',
              p2: 'Są to psy niezwykle wrażliwe, które wymagają delikatnego, ale i konsekwentnego podejścia. Najlepiej czują się w centrum uwagi, obdarzane miłością i pieszczotami. W zamian oferują bezgraniczne oddanie i stają się prawdziwymi członkami rodziny.'
            }
          },
          gallery: {
            title: 'Galeria',
            subtitle: 'Chwile z życia naszej hodowli uchwycone w kadrze.',
            photos_count: 'zdjęć'
          },
          contact: {
            title: 'Kontakt',
            subtitle: 'Masz pytania? Zapraszamy do rozmowy.',
            details: {
              title: 'Dane kontaktowe',
              name: 'Agata Columbano',
              location: 'Gdańsk, Polska'
            },
            form: {
              title: 'Napisz do nas',
              name_label: 'Imię i nazwisko',
              email_label: 'Adres email',
              message_label: 'Wiadomość',
              submit_button: 'Wyślij wiadomość',
              sending: 'Wysyłanie...',
              success: 'Wiadomość została wysłana pomyślnie! Odpowiemy najszybciej jak to możliwe.',
              error: 'Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie.',
              validation: {
                name_required: 'Imię i nazwisko jest wymagane',
                email_required: 'Adres email jest wymagany',
                email_invalid: 'Podaj prawidłowy adres email',
                message_required: 'Wiadomość jest wymagana'
              }
            },
            footer: {
              copyright: 'Wszelkie prawa zastrzeżone',
              createdBy: 'Twórca strony:',
            }
          }
        }
      }
    }
  });

export default i18n; 